import { Component } from "react"

class DiscordUserName extends Component{
    constructor(props){
        super(props)
        this.name = "Discord User Name"
    }
    validate(callbackDialog,requireCheck){
        if(requireCheck && String(this.props).trim().length === 0){
            callbackDialog("エラー",this.name + "は必須です。")
            return false
        }
        if(String(this.props).trim().length > 0){
            if(this.props.length > 30){
                callbackDialog("エラー",this.name + "は30文字以内にしてください。")
                return false
            }
            if(!/^[a-zA-Z0-9_.]{1,30}$/.test(this.props)){
                callbackDialog("エラー",this.name + "の形式ではありません。")
                return false
            }
        }
        return true
    }
}

export default DiscordUserName;